import { useEffect } from "react";

const SITE_URL = "https://www.batistamosaico.com.br";
const DEFAULT_IMAGE = SITE_URL + "/institucional/logo-mosaico-share.png";

function setMeta(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Atualiza <title>, meta description, canonical e Open Graph/Twitter por rota.
//
// LIMITAÇÃO CONHECIDA (documentada no PRD, seção "SEO & descoberta orgânica"):
// isso roda no cliente, depois do primeiro paint — cobre o que o navegador
// mostra e o que aparece ao compartilhar um link já carregado, mas rastreadores
// que não executam JS (e a maioria dos previews de link do WhatsApp/redes)
// só veem o <title>/meta description que já estavam no public/index.html no
// primeiro request. A correção completa exige SSR/SSG (ex.: migrar pra
// Next.js, ou um passo de pré-renderização no build) — fica registrado como
// requisito técnico de uma fase futura, não resolvido aqui.
export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);

    const url = SITE_URL + (path || "/");
    setCanonical(url);
    setMeta("property", "og:title", title || "Igreja Batista Mosaico");
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", DEFAULT_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title || "Igreja Batista Mosaico");
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", DEFAULT_IMAGE);
  }, [title, description, path]);
}

// Exportados pra reaproveitar a mesma logica de canonica/OG fora das
// paginas institucionais -- ver PrototypeApp.js (rotas publicas de
// ebook/trilha dentro de /familia), que antes so atualizava o <title> e
// deixava canonica/description/OG sempre apontando pra home (causa real de
// "Detectada, mas nao indexada" no Search Console pra essas paginas).
export { SITE_URL, DEFAULT_IMAGE, setMeta, setCanonical };
